import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatZipcode' })
export class FormatZipcodePipe implements PipeTransform {
  transform(value: string) {
    if (value.length === 9) {
      return value.substring(0, 5);
    } else {
      return value;
    }
  }
}
